<div class="modal-header movable flex flex-row justify-between align-center" cdkDrag
     cdkDragRootElement=".cdk-overlay-pane"
     cdkDragHandle>
  <h1>Error Report</h1>

  <mat-dialog-actions>
    <button class="material-icons" mat-dialog-close
            particleAnalytics
            analyticsCategory="add-task-diaolog"
            analyticsAction="close-btn">close
    </button>
  </mat-dialog-actions>

</div>
<div class="blue-box-container m-t-20 flex flex-row justify-between items-center">
  <span>Note:</span> <span>We have identified {{recordCount}} error(s) with your exported form(s). Please see the errors and validation details below.</span>
</div>
<mat-dialog-content>
  <div class="simple-scroll flex flex-row justify-center items-start full-grow-no-shrink-no-basis">
    <div class="content pos-relative max-height flex flex-col full-grow-no-shrink-no-basis">
      <div class="keno-grid-container">
        <particle-virtual-grid [sourceKey]="sourceKey"
                               [invalidateSubject]="invalidateSubject"
                               sortFieldKey="FieldValues.Order"
                               sortDirection="asc"
                               (recordCountChanged)="onRecordCountChange($event)"
                               (valueChanged)="onGridCellValueChange($event)"
                               [parameters]="gridParams"
        >
        </particle-virtual-grid>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">
  <button class="common-button" (click)="onCancel()"
          analyticsCategory=""
          analyticsAction="" mat-button="" particleAnalytics="">
    Cancel
  </button>
  <!--<button class="common-button" (click)="errorAction('download-form')"
          analyticsCategory=""
          analyticsAction="" mat-button="" particleAnalytics="">
    Download Forms(.zip)
  </button>-->
  <div class="flex flex-row justify-start items-center">
    <button class="common-button m-r-20" (click)="errorAction('download-error')"
            analyticsCategory=""
            [disabled]="!data.hasError"
            analyticsAction="" mat-button="" particleAnalytics="">
      Download Errors (.xlsx)
    </button>
    <button class="action-button" *ngIf="!data.transmitToAuthority"
            analyticsCategory="" (click)="errorAction('download-form')"
            analyticsAction="" mat-button="" particleAnalytics="">
      {{downloadText}}
    </button>
    <button class="action-button" *ngIf="data.transmitToAuthority"
            analyticsCategory="" (click)="errorAction('transmit-to-authority')"
            analyticsAction="" mat-button="" particleAnalytics="">
      Next
    </button>
  </div>


</mat-dialog-actions>






